import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ShareComment } from 'ThreeTerminal_mobile_dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';

class HotComment extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        subid: PropTypes.string,
        wxLaunch: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content, subid, wxLaunch } = this.props;
        const subidVal = subid ? `&subid=${subid}` : '';
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };
        let callAppType = content.type === 'article' ? 'doc' : content.type;

        callAppType = callAppType === 'slide' ? 'immersionslide' : callAppType;
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        
        const commentInfo1 = {
            id: content._id || content.base62Id + subidVal,
            callType: callAppType,
            docUrl: `ucms_${content.base62Id}`, // 文章单页的页面地址
            docTitle: content.title, // 文章的标题
            skey: content.skey, // 文章评论的skey，这个是在后端生成好后给到前端的
            speUrl: '', // 兼容以后的专题评论
            pcUrl: content.pcUrl, // 文章pc的页面地址
            cmtNumUrl: `https://${ commentDomain }/get.php`, // 获取评论内容接口
            cmtLength: 1000, // 评论内容字数长度
            cmtPostUrl: `https://${ commentDomain }/post.php`, // 提交评论内容接口
            hotLimit: 3, // 最热评论数量
            limitHeight: '', // 评论区域的高度限制
            cmtVoteUrl: `https://${ commentDomain }/vote.php`, // 推荐评论接口
            replyLimit: 3, // 显示回复的楼层
            jubUrl: `https://${ commentDomain }/report`, // 举报提交接口
            jubNum: 0, // 举报次数，便于每次回调函数名不同
            isComment: false, // 是否是评论详情页面
            kind: 'share52205', // 拉起kind值
            clickCount: {
                behavior: 'action',
                type: 'comtmore',
                other: {
                    rel: `ucms_${content.base62Id}`,
                    kind: 'article',
                },
            },
            downloads,
            isVideoShare: content.isVideoShare,
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        };

        return (
            <section className={styles.commentBox}>
                <ShareComment articleInfo={commentInfo1} />
            </section>
        );
    }
}

export default errorBoundary(HotComment);
